import { type Site } from '../../entities/site';

export const MOCK_SITES: Site[] = [
  {
    id: '12345',
    fullFrontendId: 'Country_Corner',
  },
  {
    id: '23456',
    fullFrontendId: 'Sunset_Plaza',
  },
  {
    id: '34567',
    fullFrontendId: 'Smart_Hill',
  },
];
